import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AlertType } from '../../utilities/types';

export interface SnackbarState {
  open: boolean;
  message: string;
  severity?: 'success' | 'error' | 'warning' | 'info';
}

interface CommonState {
  snackbar: SnackbarState;
  showLoader: boolean;
  [key: string]: any;
}

const initialState: CommonState = {
  snackbar: {
    open: false,
    message: '',
    severity: 'info',
  },
  showLoader: false,
  systemConfig: {},
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    showSnackbar: (
      state,
      action: PayloadAction<{
        message: string;
        severity?: AlertType;
      }>
    ) => {
      state.snackbar = {
        ...state.snackbar,
        open: true,
        message: action.payload.message,
        severity: action.payload.severity || 'info',
      };
    },
    hideSnackbar: (state) => {
      state.snackbar = {
        ...state.snackbar,
        open: false,
        message: '',
        severity: 'info',
      };
    },
    showLoader: (state) => {
      state.showLoader = true;
    },
    hideLoader: (state) => {
      state.showLoader = false;
    },
    setSystemConfig: (state, action: PayloadAction<any>) => {
      state.systemConfig = JSON.parse(JSON.stringify(action.payload));
    },
  },
});

export const { showSnackbar, hideSnackbar, showLoader, hideLoader, setSystemConfig } =
  commonSlice.actions;
export default commonSlice.reducer;
